import { render } from "./LabelledText.vue?vue&type=template&id=32dd8c64&scoped=true"
import script from "./LabelledText.vue?vue&type=script&lang=js"
export * from "./LabelledText.vue?vue&type=script&lang=js"

import "./LabelledText.vue?vue&type=style&index=0&id=32dd8c64&lang=scss&scoped=true"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32dd8c64"]])

export default __exports__